import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Ano de início da carreira docente do Pedro.
// Os anos de experiência atualizam sozinhos a cada novo ano (2026 → 29, 2027 → 30, ...).
export const ANO_INICIO_CARREIRA = 1997;
export const anosExperiencia = new Date().getFullYear() - ANO_INICIO_CARREIRA;
